import { AlertConstant } from '../actions/constants/AlertConstant';
const initialState = 
{ 
    type : "", 
    message : "",
    simplemessage : "",
    errors : [],
    isClose : false,
    menuOpen : false,
    topOption : {
        title : "RayGuard",
        type : "normal"
    },
};
export const AlertReducer = (state = initialState, action) => {
    switch (action.type) {
        case AlertConstant.SUCCESS:
            return {  
                type: 'alert-success', 
                message: action.message, 
                errors : [],
                isClose : false 
            };
        case AlertConstant.ERRORMSG:
            return {  
                type: 'alert-danger', 
                message: action.message, 
                errors : [],
                isClose : false 
            };
        case AlertConstant.ERROR:
            if(typeof action.data == "string"){
                action.data = { errmsg : action.data, errors : [] }
            }
            return {...state,
                type: 'alert-danger',
                // BUG-225 (#443): App.js 토스트가 message 를 그대로 렌더하므로 항상 문자열이어야
                // 한다 — 객체/배열이 실리면 React child 오류로 ErrorBoundary 전체 화면 대체.
                // BUG-227 (#446): 표시 문자열은 AlertAction.Error 가 확정해 action.message 로 보낸다.
                // action.data?.errmsg 폴백은 ERROR 를 직접 dispatch 하는 경우를 위한 방어 분기다.
                message: (typeof action.message === 'string' && action.message !== '')
                    ? action.message
                    : (typeof action.data?.errmsg === 'string' ? action.data.errmsg : ''),
                simplemessage : typeof action.code === 'string' ? action.code : '',
                errors : action.data,
                isClose : false
            };
        case AlertConstant.CLEAR:
            return initialState;
        case AlertConstant.CLOSED:
            return {...state, isClose : true };
        case AlertConstant.SIDEMENU_CLOSE:
            return {...state, menuOpen : false };
        case AlertConstant.SIDEMENU_OPEN:
            return {...state, menuOpen : true };
        case AlertConstant.SET_TOP:
            return {...state, topOption : action.opt };
        default:
            return state
    }
}